module.exports = __webpack_public_path__ + "img/Asymmetry.27d01727.png";